export const MAIN_PHOTO_ID = 'front'

const DEFAULT_SCALE = 1.1

export function getDefaultWallScale() {
  return DEFAULT_SCALE
}

export const ENTRY_POINT_SOURCE = {
  MENU: 'Menu',
  FOOTER: 'Footer',
  BACK: 'Back',
  CAMPAIGN: 'Campaign',
  DIRECT: 'Direct',
}

// The bottom height is according to a fixed asset ratio the designer has decided on
export const BOTTOM_SIDE_HEIGHT = 79

export function getSmallScreenRenderHeight() {
  return window.innerHeight - BOTTOM_SIDE_HEIGHT
}
